module.exports = __webpack_public_path__ + "static/Mobile_screen-e6426f61f6b66daf07eafb78a9ed68a4.svg";